"use client";

import { JSX, useReducer } from "react";
import {
  AdContext,
  AdDispatchContext
} from "rivals/components/shared/Ads/adContext";
import type { ProviderProps } from "./types";

export type AdStateKeys = "ldrbSlot" | "lrecSlot" | "locationOffset";

export type AdState = Record<AdStateKeys, number>;

export interface IncrementAdSlot {
  payload: "ldrb" | "lrec";
  type: "INCREMENT_AD_SLOT";
}

function reducer(state: AdState, action: IncrementAdSlot): AdState {
  switch (action.type) {
    case "INCREMENT_AD_SLOT": {
      if (action.payload === "ldrb") {
        return {
          ...state,
          ldrbSlot: state.ldrbSlot + 1,
          locationOffset: state.locationOffset + 1
        };
      } else {
        return {
          ...state,
          locationOffset: state.locationOffset + 1,
          lrecSlot: state.lrecSlot + 1
        };
      }
    }
    default:
      return state;
  }
}

export default function AdProvider({
  children,
  ldrbOffset = 0,
  lrecOffset = 0
}: ProviderProps): JSX.Element {
  const [state, dispatch] = useReducer(reducer, {
    ldrbSlot: 1 + ldrbOffset,
    locationOffset: 0,
    lrecSlot: 1 + lrecOffset
  });

  return (
    <AdContext.Provider value={state}>
      <AdDispatchContext.Provider value={dispatch}>
        {children}
      </AdDispatchContext.Provider>
    </AdContext.Provider>
  );
}
